import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AD_UNIT_FOR_PRODUCT_TABLE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_PAGINATED_AD_UNITS_FOR_PRODUCT_TABLE = (
  ability: Ability,
): TypedDocumentNode<Data, Variables> => gql`
  ${AD_UNIT_FOR_PRODUCT_TABLE_FRAGMENT(ability)}

  query getPaginatedAdUnitsForProductTable(
    $domainId: ID
    $first: Int
    $last: Int
    $terms: [String!]
    $workspaceId: ID!
    $sort: AdUnitSortInput
  ) {
    adUnits(
      domainId: $domainId
      first: $first
      last: $last
      terms: $terms
      workspaceId: $workspaceId
      sort: $sort
    ) {
      nodes {
        ...AdUnitForProductTableFragment
      }

      totalCount
    }
  }
`
